import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../interfaces/IReduxState";
import { IPurchaseOrder } from "../../pages/purchase-order/IPurchaseOrder";

const EditPurchaseOrderSlice = createSlice({
  name: "EditPurchaseOrder",
  initialState: {} as IReduxState<IPurchaseOrder[]>,
  reducers: {
    editPurchaseOrderStart: (state, _) => {
      state.isLoading = true;
    },
    successEditPurchaseOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureEditPurchaseOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearEditPurchaseOrder: (state) => {
      state.data = {};
    },
  },
});

export const {
  editPurchaseOrderStart,
  successEditPurchaseOrder,
  failureEditPurchaseOrder,
  clearEditPurchaseOrder,
} = EditPurchaseOrderSlice.actions;

export default EditPurchaseOrderSlice.reducer;
